import type {IModifyTemplateGraph} from "@cm/template-nodes"
import type {
    InitStackableMattressStandardModelMasterTemplateOptions,
    InitMattressInstanceTemplateOptions,
} from "#mattress/assets-definitions/standard-models/common/model-factory"
import {getDefaultHandlesParameters, initInstanceTemplateCommon} from "#mattress/assets-definitions/standard-models/common/model-factory"
import {createTemplateReference} from "#mattress/assets-definitions/common"
import {initSimplePocketMasterTemplate} from "#mattress/assets-definitions/standard-models/pocket"
import {initSimpleWaterfallMasterTemplate} from "#mattress/assets-definitions/standard-models/waterfall"
import {initEdgeMasterTemplate} from "#mattress/assets-definitions/standard-models/edge"

export function initPocketTopperMasterTemplate(
    modifyTemplateGraph: IModifyTemplateGraph,
    options: InitStackableMattressStandardModelMasterTemplateOptions = {openingOnBottom: false},
) {
    return initSimplePocketMasterTemplate(modifyTemplateGraph, options)
}

export function initPocketTopperInstanceTemplate(
    modifyTemplateGraph: IModifyTemplateGraph,
    masterTemplateDataLegacyId: number,
    options: InitMattressInstanceTemplateOptions,
) {
    const optionsParameters = {
        ...(options.parameters ? options.parameters : {}),
        width: 90,
        length: 200,
        "top-height": 2.5,
        "bottom-height": 2.5,
        "corner-radius": 3,
        "top-radius": 2,
        "bottom-radius": 2,
        "layer-count": 0,
        "accessories-bottom-curve/accessory-count": 1,
        "accessories-bottom-curve/accessory-stack/accessory-0/accessory": createTemplateReference(options.accessoriesTemplatesLegacyIds["zipper Teeth, M5"]),
        "accessories-bottom-curve/accessory-stack/accessory-0/accessory/puller-0/puller-template": createTemplateReference(
            options.accessoriesTemplatesLegacyIds["puller Square Big Hole Puller (r619) with Slider, M5"],
        ),
        "accessories-bottom-curve/accessory-stack/accessory-0/accessory/puller-0/puller-offset": 0.998,
        ...getDefaultHandlesParameters(options),
    }

    initInstanceTemplateCommon(
        modifyTemplateGraph,
        {
            legacyId: masterTemplateDataLegacyId,
            instanceName: "Pocket topper (Master)",
            instanceId: "pocket-topper-master",
        },
        {
            ...options,
            parameters: optionsParameters,
        },
    )
}

export function initWaterfallTopperMasterTemplate(
    modifyTemplateGraph: IModifyTemplateGraph,
    options: InitStackableMattressStandardModelMasterTemplateOptions = {openingOnBottom: false},
) {
    return initSimpleWaterfallMasterTemplate(modifyTemplateGraph, {
        ...options,
        topPartFabricLayout: "Waterfall",
        bottomPartFabricLayout: "InvertedWaterfall",
        middlePartFabricLayout: "Border",
    })
}

export function initWaterfallTopperInstanceTemplate(
    modifyTemplateGraph: IModifyTemplateGraph,
    masterTemplateDataLegacyId: number,
    options: InitMattressInstanceTemplateOptions,
) {
    const optionsParameters = {
        ...(options.parameters ? options.parameters : {}),
        width: 90,
        length: 200,
        "top-height": 5,
        "bottom-height": 1,
        "corner-radius": 3,
        "top-radius": 2,
        "bottom-radius": 2,
        "layer-count": 0,
        "accessories-bottom-curve/accessory-count": 1,
        "accessories-bottom-curve/accessory-stack/accessory-0/accessory": createTemplateReference(options.accessoriesTemplatesLegacyIds["zipper Teeth, M5"]),
        "accessories-bottom-curve/accessory-stack/accessory-0/accessory/puller-0/puller-template": createTemplateReference(
            options.accessoriesTemplatesLegacyIds["puller Square Big Hole Puller (r619) with Slider, M5"],
        ),
        "accessories-bottom-curve/accessory-stack/accessory-0/accessory/puller-0/puller-offset": 0.998,
        ...getDefaultHandlesParameters(options),
    }

    initInstanceTemplateCommon(
        modifyTemplateGraph,
        {
            legacyId: masterTemplateDataLegacyId,
            instanceName: "Waterfall topper (Master)",
            instanceId: "waterfall-topper-master",
        },
        {
            ...options,
            parameters: optionsParameters,
        },
    )
}

export function initEdgeTopperMasterTemplate(
    modifyTemplateGraph: IModifyTemplateGraph,
    options: InitStackableMattressStandardModelMasterTemplateOptions = {openingOnBottom: false},
) {
    return initEdgeMasterTemplate(modifyTemplateGraph, options)
}

export function initEdgeTopperInstanceTemplate(
    modifyTemplateGraph: IModifyTemplateGraph,
    masterTemplateDataLegacyId: number,
    options: InitMattressInstanceTemplateOptions,
) {
    const optionsParameters = {
        ...(options.parameters ? options.parameters : {}),
        width: 90,
        length: 200,
        "top-height": 1,
        "bottom-height": 5,
        "corner-radius": 3,
        "top-radius": 1,
        "bottom-radius": 1,
        "layer-count": 0,
        "accessories-bottom-panel/accessory-count": 2,
        "accessories-bottom-panel/accessory-stack/accessory-0/accessory": createTemplateReference(options.accessoriesTemplatesLegacyIds["piping 5.5mm"]),
        "accessories-bottom-panel/accessory-stack/accessory-1/accessory": createTemplateReference(options.accessoriesTemplatesLegacyIds["zipper Teeth, M5"]),
        "accessories-bottom-panel/accessory-stack/accessory-1/accessory/puller-0/puller-template": createTemplateReference(
            options.accessoriesTemplatesLegacyIds["puller Standard Puller (YKK, n56) with Slider, M5"],
        ),
        "accessories-bottom-panel/accessory-stack/accessory-0/accessory/puller-0/puller-template": createTemplateReference(
            options.accessoriesTemplatesLegacyIds["puller Square Big Hole Puller (r619) with Slider, M5"],
        ),
        "accessories-bottom-panel/accessory-stack/accessory-0/accessory/puller-0/puller-offset": 0.998,
        "accessories-bottom-curve/accessory-count": 1,
        "accessories-bottom-curve/accessory-stack/accessory-0/accessory": createTemplateReference(options.accessoriesTemplatesLegacyIds["piping 5.5mm"]),
        ...getDefaultHandlesParameters(options),
    }

    initInstanceTemplateCommon(
        modifyTemplateGraph,
        {
            legacyId: masterTemplateDataLegacyId,
            instanceName: "Edge topper (Master)",
            instanceId: "edge-topper-master",
        },
        {
            ...options,
            parameters: optionsParameters,
        },
    )
}
